<script>
	import { Button, Col, Row } from "sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import VehicleMakeTable from "./VehicleMakeTable.svelte";
	import { form, field, combined } from "svelte-forms";
	import { onMount } from "svelte";
	import { navigate } from "svelte-routing";
	import {
		errorMessage,
		loading,
		totalPages,
		loadingStatus,
		vehicleEditData,
	} from "../../../../store/store";
	import client from "../../../../services/client";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import {
		required,
		min,
		max,
		email,
		pattern,
	} from "svelte-forms/validators";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";

	let idMake = window.location.pathname.split(
		"master-data/vehicle-data/vehicle-make/edit/"
	)[1];
	let data = [];
	let carMakeError;
	const carMake = field("carMake", $vehicleEditData.name, [required()]);
	const myForm = form(carMake);

	let load = false;
	const handleSubmit = async () => {
		try {
			load = true;
			loading.set(true);
			const res = await client("/v1/makes", {
				method: "PUT",
				version: "Vehicle",
				data: {
					name: $carMake.value,
					id: idMake,
				},
			});

			if (res?.status === 200) {
				navigate("/master-data/vehicle-data/vehicle-make");
			} else {
				loading.set(false);
				carMakeError = res.data.message;
			}

			load = false;
			loading.set(false);
		} catch (error) {
			load = false;
			carMakeError = error.response.data.message;
			loading.set(false);
		}
	};
</script>

<Row>
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Vehicle Make Data" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Edit Vehicle Make</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="mobile" class="d-block">
						<span> Vehicle Make* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomInput
						type="text"
						bind:value={$carMake.value}
						error={$myForm.hasError("carMake.required") ||
							carMakeError}
						errorText={$myForm.hasError("carMake.required")
							? "Vehicle make is required"
							: carMakeError
							? carMakeError
							: ""}
					/>
				</Col>
				<Col class="d-flex justify-content-start" xs={6}>
					<div class="mx-4 my-1">
						<Button
							class="themeButton primary px-2"
							block
							disabled={!$myForm.valid || !$carMake.value}
							on:click={myForm.validate}
							on:click={() => handleSubmit()}
						>
							{#if load}
								<Loader />
							{:else}
								Edit
							{/if}
						</Button>
					</div>
				</Col>
			</Row>
		</Col>
	</Col>
</Row>
